import {hasLoggedAGenericUser} from "./userHelper";
import {
  InterferometricStackSearchResultsType,
  ProductImageSearchResultsType, ProductImageStacType, SearchResultElementType,
  SearchResultsType
} from "../types/product";
import {ConfigurationsType} from "../types/configurations";
import {getCoordinatesFromSearchResultElement} from "./shapeHelper";
import {ShapeType} from "../types/shape";
import {IsAlreadyInTheCart} from "./cartHelper";
import {CartOrderType} from "../types/cart";
import {AppParametersType} from "../types/app";
import translations from "../translations";

export const hasResultsPageLimits = (
    appParametersType: AppParametersType,
    searchFormValues
) => {
  const inOnDemandValue = !searchFormValues.routine;
  const hasLoggedAGenericUserValue = hasLoggedAGenericUser();
  return inOnDemandValue && (hasLoggedAGenericUserValue);
}

export const PAGE_SIZE_FIELD_TYPE_OPTIONS = [
  {label: 'tenResultsPerPage', value: 10},
  {label: 'twentyfiveResultsPerPage', value: 25},
  {label: 'fiftyResultsPerPage', value: 50},
  {label: 'hundredResultsPerPage', value: 100}
];

export const INTERFEROMETRIC_STACK_SEARCH_ORDER_BY_FIELDS = [
  {
    description: "mission",
    type: "string",
    name: "mission",
    sequence: 1
  },
  {
    description: "acqMode",
    type: "string",
    name: "acquisition_mode",
    sequence: 2
  },
  {
    description: "passDirection",
    type: "string",
    name: "orbit_direction",
    sequence: 3
  },
  {
    description: "stackIdentifier",
    type: "string",
    name: "identifier",
    sequence: 4
  },
  {
    description: "polarization",
    type: "string",
    name: "polarization",
    sequence: 5
  }
];

export const INTERFEROMETRIC_STACK_DETAILS_ORDER_BY_FIELDS = [
  {
    description: "Platform",
    type: "string",
    name: "platform",
    sequence: 1
  },
  {
    description: 'acqDateStartSearchResults',
    type: "date",
    name: "start_datetime",
    sequence: 2
  },
];

export const isProductImageSearchResults = (searchResults: SearchResultsType): boolean => (
  searchResults && "items" in searchResults
);

export const isInterferometricStackSearchResults = (searchResults: SearchResultsType): boolean => (
  searchResults && "stacks" in searchResults
);

export const isProductImageSearchResultElement = (searchResultElement: SearchResultElementType): boolean => (
  searchResultElement && !("items" in searchResultElement)
);

export const isInterferometricStackSearchResultElement = (searchResultElement: SearchResultElementType): boolean => (
  searchResultElement && "items" in searchResultElement
);

export const getAllSelectableProductImagesFrom = (
  configurations: ConfigurationsType,
  ordersSubmitted: CartOrderType[],
  searchResults: SearchResultsType
): ProductImageStacType[] => {
  let allProductImages: any;
  allProductImages = isProductImageSearchResults(searchResults)
      ? (searchResults as ProductImageSearchResultsType).items
      : (searchResults as InterferometricStackSearchResultsType).stacks
          .reduce((acc: ProductImageStacType[], {items}) => acc.concat(items), [])
  return allProductImages.filter((productImage: ProductImageStacType) => {
    return isSelectableProductImage(configurations, ordersSubmitted, productImage);
  })
};

export const isSelectableProductImage = (configurations, ordersSubmitted, productImage) => {
  return !IsAlreadyInTheCart(configurations, ordersSubmitted, productImage)
}

export const getOrderByFieldNameOptionsFrom = (
  configurations: ConfigurationsType,
  searchResults: SearchResultsType,
  language: string
) => (
  getSortFieldsFrom(configurations, isInterferometricStackSearchResults(searchResults), language)
    .map(({description, name}) => ({ label: translations(description, language), value: name }))
);

export const getSortFieldsFrom = (
  configurations: ConfigurationsType,
  isInterferometricStackSearch: boolean = false,
  language: string
) =>
    {
      return isInterferometricStackSearch ? INTERFEROMETRIC_STACK_SEARCH_ORDER_BY_FIELDS.map(el => {
        return {
          description: translations(el.description, language),
          type: el.type,
          name: el.name,
          sequence: el.sequence
        }
      }) : configurations.fields.sort;
    };

export const isSearchResultElementAvailable = (
  configuration: ConfigurationsType,
  appParameters: AppParametersType,
  searchResultElement: SearchResultElementType,
  selectedProducts: ProductImageStacType[],
  selectedArea: ShapeType
): boolean => (
  !!searchResultElement && getCoordinatesFromSearchResultElement(configuration, appParameters, searchResultElement, selectedProducts, selectedArea).length > 0
);
